import React from 'react';
import {observer} from "mobx-react-lite";
import {useServices} from "../../../../react-hooks/use-services.hook";
import {HeaderWelcomeButtonsForAuthorizedUserMobileViewComponent} from "../../../header/welcome-buttons/authorized-user/mobile-view/header-welcome-buttons-for-authorized-user-mobile-view.component";
import {VideoSlidesArenaHeaderBox} from "./boxes/video-slides-arena-header.box";
import {VideoSlidesArenaFiltersIndicator} from './components/video-slides-arena-filters-indicator/video-slides-arena-filters-indicator.component';
import {VideoSlideRegulatoryDataBox} from './boxes/video-slide-regulatory-data.box';
import {
    VideoSlidesUserMenuButtonBox
} from "./components/video-slides-header-filter-button/video-slides-user-menu-button/video-slides-user-menu-button.box";
import {VideoSlidesArenaRegulatoryDataBox} from './boxes/regulatory/video-slides-arena-regulatory-data.box';
import {VideoSlidesArenaHeaderConfiguration} from '../../../../services/configurations/config-data-sections/arenas.configuration';
import {Check} from '@sparkware/app-utils';
import {DialogButtonClickHandleResultEnum} from "./../../../../services/dialog/dialog.service.interface";
import {LicenseStatusBox} from "./boxes/regulatory/license-status/license-status.box";
import {
    VideoSlidesLicensePopupContentComponent
} from "./components/video-slides-license-popup-content/video-slides-license-popup-content.component";
import {CyClass} from "../../../../../common/cy-classes";
import {MinimumGamblingAgeComponent} from '../../../responsible-gambling/minimum-gambling-age/minimum-gambling-age.component';

export const VideoSlidesHeaderArena: React.FC = observer(() => {
    const services = useServices();

    const renderHeaderWelcomeButtonsForAuthorizedUserMobile = () => {
        if (services.user.isAuthorized) {
            return (
                <VideoSlidesUserMenuButtonBox>
                    <HeaderWelcomeButtonsForAuthorizedUserMobileViewComponent />
                </VideoSlidesUserMenuButtonBox>
            );
        }
    }

    const renderLicenseStatus = () => {
        const videoSlidesArenaHeaderConfiguration: VideoSlidesArenaHeaderConfiguration = services.configuration.data.arenas.videoSlidesArena.header;
        if (Check.isNullOrUndefined(videoSlidesArenaHeaderConfiguration?.licenseStatus) || videoSlidesArenaHeaderConfiguration?.licenseStatus.display === false) {
            return null;
        }

        return (
            <LicenseStatusBox onClick={_showLicenseStatusDialog} className={CyClass('cy-license-status-button')}>
                {services.translation.translate(videoSlidesArenaHeaderConfiguration?.licenseStatus.text)}
            </LicenseStatusBox>
        );
    }

    const renderMinimumGamblingAge = () => {
        const videoSlidesArenaHeaderConfiguration: VideoSlidesArenaHeaderConfiguration = services.configuration.data.arenas.videoSlidesArena.header;
        if (Check.isNullOrUndefined(videoSlidesArenaHeaderConfiguration?.minimumGamblingAge) || videoSlidesArenaHeaderConfiguration?.minimumGamblingAge.display === false) {
            return null;
        }

        return <MinimumGamblingAgeComponent />
    }

    const _showLicenseStatusDialog = () => {
        const WarningIcon = services.theme.currentTheme.icons.warningSignIcon;
        services.dialog.showSimpleTextModal({
            title: services.translation.translate("UK_LICENSE_STATUS"),
            text: <VideoSlidesLicensePopupContentComponent/>,
            showEmptyTitle: true,
            icon: <WarningIcon style={{display: "inline"}} size={5.6} />,
            disableFullscreenMobile: true,
            buttons: [
                {
                    text: services.translation.translate('OK'),
                    buttonPreset: 'primary',
                    onClick: async () => DialogButtonClickHandleResultEnum.CloseDialogAndContinue
                }
            ]
        });
    }


    return (
        <>
            <VideoSlidesArenaRegulatoryDataBox>
                <VideoSlideRegulatoryDataBox attachToHeaderService={true} />
                {renderLicenseStatus()}
                {renderMinimumGamblingAge()}
            </VideoSlidesArenaRegulatoryDataBox>
            <VideoSlidesArenaHeaderBox>
                <VideoSlidesArenaFiltersIndicator />
                {renderHeaderWelcomeButtonsForAuthorizedUserMobile()}
            </VideoSlidesArenaHeaderBox>
        </>
    );
})